<template>
  <div id="about-me" class="relative bg-gray-100 dark:bg-gray-800 p-8 rounded-2xl shadow-lg border dark:border-gray-700 mb-8">
    <!-- Section Title with Underline Effect -->
    <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100 relative inline-block mb-6">
      About Me
      <span class="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></span>
    </h2>

    <div class="dark:text-gray-300 text-gray-700 space-y-5 leading-relaxed text-justify">
      <p>
        As a full-stack software engineer, I have worked with various industry projects that use frameworks,
        including <span class="font-semibold text-gray-900 dark:text-gray-100">Laravel, Django, Svelte,</span> and
        <span class="font-semibold text-gray-900 dark:text-gray-100">Vue</span>. My preferred stack is Laravel and Vue.
      </p>

      <p>
        My specialty lies in my thought process and logic-building power. I frequently practice on
        <span class="text-green-500 font-semibold">Leetcode</span> to enhance my command of data structures and coding skills.
      </p>

      <p>
        On the server side, I have experience with Apache and Nginx, managing and handling production deployments.
        Additionally, I have practical experience with various AWS cloud services, including
        <span class="font-semibold">EC2, S3, Lambda functions, ACM, Route 53,</span> and <span class="font-semibold">CloudFront Distributions</span>.
      </p>

      <p>
        I have a strong command of <span class="font-semibold">Git</span>. Furthermore, I have integrated and utilized performance
        tools such as <span class="text-purple-500 font-semibold">New Relic</span> and <span class="text-red-500 font-semibold">Bugsnag</span>.
      </p>

      <p>
        Besides my technical skills, I communicate effectively and transparently. At SystemsD, I have experience working both in a team and independently.
        Currently, I am leading an intern on a project that uses Laravel and Vue, which is a freelancing platform featuring three different dashboards:
        <span class="font-semibold">Admin, Client,</span> and <span class="font-semibold">Expert</span>.
      </p>

      <!-- Profile Links -->
      <div class="flex flex-col sm:flex-row gap-4 mt-6">
        <a href="https://leetcode.com/u/bGap4znztN/" target="_blank"
           class="px-5 py-3 bg-blue-500 text-white font-medium rounded-lg shadow-md hover:bg-blue-600 transition">
          🖥️ Leetcode Profile
        </a>
        <a href="https://www.codewars.com/users/ranahamza11" target="_blank"
           class="px-5 py-3 bg-red-500 text-white font-medium rounded-lg shadow-md hover:bg-red-600 transition">
          ⚔️ Codewars Profile
        </a>

      </div>
    </div>
  </div>
</template>
